{
  "已认证企业": "Verified enterprises",
  "待审核认证": "Pending certifications",
  "待处理反馈": "Pending feedback",
  "刷新数据": "Refresh data",
  "待处理事项": "Pending tasks",
  "企业认证": "Enterprise certification",
  "投诉与意见": "Complaints and feedback",
  "运营入口": "Quick access",
  "暂无待审核认证": "No pending certifications",
  "暂无待处理反馈": "No pending feedback",
  "重新加载待办": "Reload tasks",
  "当前账号暂无运营工作台权限": "This account does not have access to the operations workbench",
  "前往个人中心": "Go to profile",
  "企业总数": "Total enterprises",
  "审核": "Review",
  "国家与地区": "Countries and regions",
  "每日经营": "Daily operations",
  "当前账号暂无每日经营权限": "Your account does not have access to daily operations",
  "业务日期": "Business date",
  "上报金额（CNY）": "Reported amount (CNY)",
  "业务依据": "Business reference",
  "请输入上报金额": "Enter the reported amount",
  "请输入非负金额，最多保留两位小数": "Enter a non-negative amount with up to 2 decimal places",
  "请输入金额": "Enter an amount",
  "业务编号、书面依据或修正原因": "Business reference, supporting document or correction reason",
  "请填写业务依据": "Enter a business reference",
  "业务依据不能超过 1000 字": "Business reference must not exceed 1,000 characters",
  "每次保存均保留录入人、时间和修订记录": "Every save records the operator, time and revision",
  "加载最新记录": "Load latest record",
  "登记 GMV": "Record GMV",
  "保存修正": "Save correction",
  "GMV 已保存": "GMV saved",
  "修订时间": "Revised at",
  "录入人": "Recorded by",
  "修正前金额": "Previous amount",
  "首次登记": "Initial entry",
  "GMV 修订记录": "GMV revision history",
  "当日暂无修订记录": "No revisions for this date",
  "选择业务日期": "Select business date",
  "查看当日": "View date",
  "按北京时间统计；GMV 为人工上报的业务金额，不等于平台收益或到账金额。": "Dates use China Standard Time. GMV is the manually reported business value, separate from platform revenue or cash received.",
  "经营数据加载失败": "Unable to load daily operations",
  "重新加载": "Reload",
  "当日上报 GMV": "Reported GMV for the date",
  "未登记": "Not recorded",
  "当日商机记录": "Opportunities created",
  "当日撮合申请": "Matching requests submitted",
  "累计登记项目": "Total registered projects",
  "未接入": "Not connected",
  "近 14 天 GMV": "GMV over the last 14 days",
  "最近 14 天 GMV": "GMV over the last 14 days",
  "近 14 天暂无 GMV 登记": "No GMV recorded in the last 14 days",
  "未登记日期不计为 0": "Unrecorded dates are not treated as zero",
  "GMV 登记与修正": "GMV entry and correction"
}
